export default __webpack_public_path__ + "static/media/download.02dd2cb2.svg";